export default {
  env: 'dev',
  BASEURL: '//test-xy-api.atido.com',
  loginPage: '//testloginxy.jingzhuan.cn',
  // apiUrlPrefix: '//test-xy-api.atido.com/api', // api server baseURL
  apiUrlPrefix: '//college-test.jingzhuan.cn/api',
  exam: '//test-exam-api.atido.com/api',
}
